import { Loader2 } from "lucide-react";
import { Box, Flex, Text } from "@radix-ui/themes";

interface LoadingScreenProps {
  fullPage?: boolean;
}

export function LoadingScreen({ fullPage = true }: LoadingScreenProps) {
  return (
    <Box
      data-testid="loading-screen"
      style={{
        position: fullPage ? "fixed" : "relative",
        inset: fullPage ? 0 : undefined,
        width: fullPage ? undefined : "100%",
        height: fullPage ? undefined : "100%",
      }}
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        gap="4"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Loader2
          style={{
            width: "2rem",
            height: "2rem",
            animation: "spin 1s linear infinite",
          }}
        />
        <Text size="2" color="gray">
          Loading...
        </Text>
      </Flex>
    </Box>
  );
}
